import { ExplanationList } from '../ExplanationList/ExplanationList'

// TODO: Replace with ExplanationList
export const ExplanationListScreen: React.FC = () => {
  return <ExplanationList />
}
